import { AppLogoProps } from './AppLogo';

const MinElektrikerLogo = ({ width = '100%', height = '100%', darkMode = false }: AppLogoProps) => {
	const src = darkMode ? '/logo/norgeseliten.png' : '/logo/norgeseliten.png';
	return <img src={src} alt="logo" width={width} height={height} />;
};

export default MinElektrikerLogo;
